"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInternalMetaData = void 0;
const React = __importStar(require("react"));
const FeatureAppLoader_1 = require("./FeatureAppLoader");
const oneaudi_os_store_1 = __importDefault(require("@oneaudi/oneaudi-os-store"));
/**
 * Access the internal MetaData Context passed down from the parent FeatureApp
 * with which this FeatureApp was initialized.
 *
 * This is intended for internal use in oneaudi-os libraries. Generally a FeatureApp
 * Developer should get all necessary information from the {@link useAppState} hook.
 * In some rare cases when there is a FeatureApp specific property passed down
 * it may be still useful to access this via {@link useInternalMetaData} directly.
 */
const fallback = { name: 'fallback' };
const FallBackContext = React.createContext(fallback);
const useInternalMetaData = () => {
    let MetaDataContext = oneaudi_os_store_1.default.get(FeatureAppLoader_1.META_DATA_STORE_KEY);
    if (!MetaDataContext) {
        MetaDataContext = FallBackContext;
    }
    const context = React.useContext(MetaDataContext);
    return context === fallback ? null : context;
};
exports.useInternalMetaData = useInternalMetaData;
